export default {
  lang_name: '\u7E41\u9AD4\u4E2D\u6587',
  tab_main: '\u4E3B\u9801', tab_upgrade: '\u5347\u7D1A', tab_prestige: '\u8F49\u751F', tab_achievement: '\u6210\u5C31', tab_mission: '\u4EFB\u52D9', tab_domination: '\u5F81\u670D', tab_settings: '\u8A2D\u5B9A',
  hud_cps: '/\u79D2', hud_boost: '\u589E\u76CA',
  main_tap_area: '\u9EDE\u64CA!', main_combo: '\u9023\u64CA',
  prod_informant: '\u7DDA\u4EBA', prod_informant_desc: '\u8857\u982D\u60C5\u5831\u6536\u96C6',
  prod_hacker: '\u99ED\u5BA2', prod_hacker_desc: '\u4EBA\u985E\u7DB2\u8DEF\u6EF2\u900F',
  prod_disguiser: '\u507D\u88DD\u5C08\u5BB6', prod_disguiser_desc: '\u4EBA\u985E\u5F62\u614B\u507D\u88DD',
  prod_mindController: '\u5FC3\u9748\u63A7\u5236\u5E2B', prod_mindController_desc: '\u4EBA\u985E\u8F3F\u8AD6\u64CD\u63A7',
  prod_secretLab: '\u79D8\u5BC6\u5BE6\u9A57\u5BA4', prod_secretLab_desc: '\u722C\u87F2\u4EBA\u79D1\u6280\u7814\u7A76',
  prod_mediaCell: '\u5A92\u9AD4\u5C0F\u7D44', prod_mediaCell_desc: '\u65B0\u805E/\u793E\u7FA4\u63A5\u7BA1',
  prod_shadowGovt: '\u5F71\u5B50\u653F\u5E9C', prod_shadowGovt_desc: '\u653F\u5BA2\u66FF\u63DB\u884C\u52D5',
  prod_deepBase: '\u6DF1\u5C64\u57FA\u5730', prod_deepBase_desc: '\u5730\u4E0B\u5DE8\u578B\u57FA\u5730',
  prod_orbitalStation: '\u8ECC\u9053\u7AD9', prod_orbitalStation_desc: '\u885B\u661F\u76E3\u63A7\u7DB2',
  prod_dimensionGate: '\u7DAD\u5EA6\u4E4B\u9580', prod_dimensionGate_desc: '\u5F9E\u6BCD\u661F\u53EC\u559A\u63F4\u8ECD',
  prod_planetController: '\u884C\u661F\u63A7\u5236\u5668', prod_planetController_desc: '\u76F4\u63A5\u63A7\u5236\u5730\u7403\u7CFB\u7D71',
  prod_galacticBeacon: '\u9280\u6CB3\u4FE1\u6A19', prod_galacticBeacon_desc: '\u8207\u7E3D\u90E8\u76F4\u901A',
  prod_locked: '\u89E3\u9396\uFF1A', prod_locked_prestige: '\u8F49\u751F {n}\u6B21', prod_locked_time: '{n}\u5206\u904A\u73A9',
  milestone_squad: '\u5C0F\u968A\u7DE8\u6210', milestone_company: '\u4E2D\u968A\u5B8C\u6210', milestone_battalion: '\u5927\u968A\u6230\u529B',
  milestone_regiment: '\u806F\u968A\u6230\u529B', milestone_division: '\u5E2B\u5718\u6230\u529B', milestone_corps: '\u8ECD\u5718\u6230\u529B',
  click_basic_training: '\u57FA\u790E\u8A13\u7DF4', click_combat_training: '\u6230\u9B25\u8A13\u7DF4',
  click_psychic_awaken: '\u5FC3\u9748\u89BA\u9192', click_transform: '\u8B8A\u5F62\u5F37\u5316',
  click_telepathy: '\u5FC3\u9748\u611F\u61C9', click_critical_eye: '\u81F4\u547D\u4E4B\u773C',
  click_dimension_sense: '\u7DAD\u5EA6\u611F\u77E5', click_galaxy_field: '\u9280\u6CB3\u529B\u5834',
  click_lethal_strike: '\u5FC5\u6BBA\u4E00\u64CA', click_absolute: '\u7D55\u5C0D\u6EF2\u900F',
  click_planet_destroyer: '\u884C\u661F\u6BC0\u6EC5\u8005', click_galaxy_finger: '\u9280\u6CB3\u9738\u4E3B\u4E4B\u6307',
  special_info_network: '\u60C5\u5831\u7DB2\u7D61', special_info_network_desc: '\u7DDA\u4EBA & \u99ED\u5BA2 x2',
  special_perfect_disguise: '\u5B8C\u7F8E\u507D\u88DD', special_perfect_disguise_desc: '\u6240\u6709\u7279\u5DE5 x1.5',
  special_mass_brainwash: '\u5927\u898F\u6A21\u6D17\u8166', special_mass_brainwash_desc: '\u5FC3\u9748\u63A7\u5236 & \u5A92\u9AD4 x3',
  special_shadow_network: '\u5F71\u5B50\u7DB2\u7D61', special_shadow_network_desc: '\u96E2\u7DDA\u6536\u5165 +25%',
  special_underground_empire: '\u5730\u4E0B\u5E1D\u570B', special_underground_empire_desc: '\u6240\u6709\u7279\u5DE5 x2',
  special_orbital_surveillance: '\u8ECC\u9053\u76E3\u63A7', special_orbital_surveillance_desc: '\u9EC3\u91D1\u4E8B\u4EF6\u983B\u7387 +50%',
  special_dimension_supply: '\u7DAD\u5EA6\u88DC\u7D66\u7DDA', special_dimension_supply_desc: '\u9EDE\u64CA\u53CE\u5165 x5',
  special_galactic_alliance: '\u9280\u6CB3\u540C\u76DF', special_galactic_alliance_desc: '\u6BCF\u79D2 \u{1F6F8} \u53CE\u5165 x10',
  special_combo_master: '\u9023\u64CA\u5927\u5E2B', special_combo_master_desc: '\u9023\u64CA\u4E0A\u9650 x3',
  special_time_warp: '\u6642\u9593\u626D\u66F2', special_time_warp_desc: '\u96E2\u7DDA\u4E0A\u9650 12\u5C0F\u6642',
  special_agent_synergy: '\u7279\u5DE5\u5354\u540C', special_agent_synergy_desc: '\u6BCF\u79D2 \u{1F6F8} \u53CE\u5165 x1.5',
  special_massive_infiltration: '\u5927\u898F\u6A21\u6EF2\u900F', special_massive_infiltration_desc: '\u6BCF\u79D2 \u{1F6F8} \u53CE\u5165 x2',
  subtab_click: '\u9EDE\u64CA', subtab_special: '\u7279\u6B8A',
  prestige_title: '\u7D44\u7E54\u91CD\u7D44', prestige_total_ip: '\u7E3D\u7D2F\u{1F6F8}', prestige_gc_gain: '\u53EF\u7372\u5F97\u{1F48E}',
  prestige_gc_current: '\u76EE\u524D\u{1F48E}', prestige_execute: '\u7D44\u7E54\u91CD\u7D44',
  prestige_confirm: '\u91CD\u7F6E\u6240\u6709\u9032\u5EA6\u4EE5\u7372\u5F97 {gc} \u9280\u6CB3\u4FE1\u7528\uFF1F',
  prestige_ad_bonus: '\u770B\u5EE3\u544A +50% \u{1F48E}', prestige_requirement: '\u9700\u8981 100\u5104+ \u{1F6F8}',
  prestige2_title: '\u9280\u6CB3\u91CD\u7D44', prestige2_cores_gain: '\u53EF\u7372\u5F97\u{1F52E}',
  prestige2_cores_current: '\u76EE\u524D\u{1F52E}', prestige2_execute: '\u9280\u6CB3\u91CD\u7D44',
  prestige2_requirement: '\u9700\u8981 15+ \u8F49\u751F\u6B21\u6578 & 100+ \u{1F48E}',
  prestige2_confirm: '\u6DF1\u5EA6\u91CD\u7F6E\u4EE5\u7372\u5F97 {cores} \u9280\u6CB3\u6838\u5FC3\uFF1F',
  pup_galaxy_mult: '\u9280\u6CB3\u500D\u7387', pup_galaxy_mult_desc: '\u6BCF\u7D1ACPS x1.5\uFF08\u758A\u52A0\u500D\u589E\uFF09',
  pup_infil_accel: '\u6EF2\u900F\u52A0\u901F', pup_infil_accel_desc: '\u8F49\u751F\u5F8C\u6BCF\u7D1A\u643A\u5E361\u5104 \u{1F6F8}\u958B\u59CB',
  pup_tap_enhance: '\u9EDE\u64CA\u5F37\u5316', pup_tap_enhance_desc: '\u6BCF\u7D1A\u9EDE\u64CA\u53CE\u5165 x2\uFF08\u758A\u52A0\u500D\u589E\uFF09',
  pup_offline_expand: '\u96E2\u7DDA\u64F4\u5C55', pup_offline_expand_desc: '\u96E2\u7DDA\u7372\u52F5\u4E0A\u9650 +1h/Lv\uFF08\u57FA\u790E8h\uFF09',
  pup_offline_eff: '\u96E2\u7DDA\u6548\u7387', pup_offline_eff_desc: '\u96E2\u7DDA\u53CE\u76CA\u7387 +10%p/Lv\uFF08\u57FA\u790E50%\uFF09',
  pup_agent_discount: '\u7279\u5DE5\u6298\u6263', pup_agent_discount_desc: '\u6BCF\u7D1A\u7279\u5DE5\u51C6\u5100\u8CBB\u7528 -10%\uFF08\u6700\u9AD8 -50%\uFF09',
  pup_auto_click: '\u81EA\u52D5\u9EDE\u64CA', pup_auto_click_desc: '\u6BCF\u7D1A\u6BCF\u79D2\u81EA\u52D5\u9EDE\u64CA3\u6B21\uFF08\u6700\u969315\u6B21/\u79D2\uFF09',
  pup_golden_luck: '\u9EC3\u91D1\u904B\u6C23', pup_golden_luck_desc: '\u9EC3\u91D1\u4E8B\u4EF6\u734E\u52F5 +20%/Lv\uFF08\u6700\u9AD8 +200%\uFF09',
  pup_combo_keep: '\u9023\u64CA\u4FDD\u6301', pup_combo_keep_desc: '\u9023\u64CA\u6301\u7E8C\u6642\u9593 +0.5\u79D2/Lv\uFF08\u57FA\u790E2\u79D2\uFF09',
  pup_quick_start: '\u5FEB\u901F\u958B\u59CB', pup_quick_start_desc: '\u8F49\u751F\u5F8C\u81EA\u52D5\u7372\u5F97\u524D5\u7A2E\u7279\u5DE5\u54041\u540D',
  p2up_galaxy_speed: '\u9280\u6CB3\u52A0\u901F', p2up_galaxy_speed_desc: '\u6BCF\u7D1A\u8F49\u751F\u6642\u{1F48E}\u7372\u53D6\u91CF x2\uFF08\u758A\u52A0\u500D\u589E\uFF09',
  p2up_auto_prestige: '\u81EA\u52D5\u8F49\u751F', p2up_auto_prestige_desc: '\u9054\u5230100\u5104 \u{1F6F8}\u6642\u81EA\u52D5\u8F49\u751F',
  p2up_permanent: '\u6C38\u4E45\u7279\u5DE5', p2up_permanent_desc: '\u8F49\u751F\u5F8C\u4FDD\u7559\u524D3\u7A2E\u521D\u59CB\u7279\u5DE5',
  p2up_dimension_accel: '\u7DAD\u5EA6\u52A0\u901F', p2up_dimension_accel_desc: '\u6BCF\u7D1ACPS x5\uFF08\u758A\u52A0\uFF0C\u6C38\u4E45\uFF09',
  p2up_galaxy_memory: '\u9280\u6CB3\u8A18\u61B6', p2up_galaxy_memory_desc: '\u8F49\u751F\u6642\u4FDD\u75593\u500B\u6D3B\u8E8D\u5A41\u76CA',
  p2up_spacetime: '\u6642\u7A7A\u626D\u66F2', p2up_spacetime_desc: '\u96E2\u7DDA\u53CE\u76CA\u7387\u63D0\u5347\u81F3100%\uFF08\u6C38\u4E45\uFF09',
  p2up_automate: '\u9280\u6CB3\u81EA\u52D5\u5316', p2up_automate_desc: '\u81EA\u52D5\u51C6\u5100\u7279\u5DE5\uFF08\u6C38\u4E45\uFF09',
  rank_e: '\u5BE6\u7FD2\u751F', rank_d: '\u521D\u7D1A\u7279\u5DE5', rank_c: '\u7279\u5DE5', rank_b: '\u8CC7\u6DF1\u7279\u5DE5',
  rank_a: '\u5E79\u90E8', rank_s: '\u5C40\u9577', rank_ss: '\u6700\u9AD8\u6307\u63EE\u5B98', rank_sss: '\u9280\u6CB3\u9738\u4E3B',
  ach_title: '\u6210\u5C31', ach_filter_all: '\u5168\u90E8', ach_filter_tap: '\u9EDE\u64CA', ach_filter_resource: '\u8CC7\u6E90',
  ach_filter_producer: '\u751F\u7522\u8005', ach_filter_prestige: '\u8F49\u751F', ach_filter_time: '\u6642\u9593',
  ach_filter_special: '\u7279\u6B8A', ach_filter_ad: '\u6587\u4EF6', ach_filter_combo: '\u9023\u64CA',
  ach_t01: '\u7B2C\u4E00\u6B65', ach_t01_reward: '+1 \u9EDE\u64CA\u529B', ach_t02: '\u6696\u8EAB', ach_t02_reward: '+5% \u9EDE\u64CA\u529B',
  ach_t03: '\u7A69\u5B9A\u7279\u5DE5', ach_t03_reward: '+10% \u9EDE\u64CA\u529B', ach_t04: '\u89F8\u63A7\u5927\u5E2B', ach_t04_reward: '+15% \u9EDE\u64CA\u529B',
  ach_t05: '\u722C\u87F2\u4EBA\u6BC5\u529B', ach_t05_reward: '+20% \u9EDE\u64CA\u529B', ach_t06: '\u9280\u6CB3\u4E4B\u6307', ach_t06_reward: '+25% \u9EDE\u64CA\u529B',
  ach_t07: '\u9023\u64CA\u5B78\u5F92', ach_t07_reward: '+0.5\u79D2 \u9023\u64CA', ach_t08: '\u9023\u64CA\u5927\u5E2B', ach_t08_reward: '+0.5 \u9023\u64CA\u4E0A\u9650',
  ach_r01: '\u5C0F\u9053\u6D88\u606F', ach_r01_reward: '+5% 每秒\u{1F6F8}', ach_r02: '\u60C5\u5831\u6536\u96C6\u8005', ach_r02_reward: '+5% 每秒\u{1F6F8}',
  ach_r03: '\u6A5F\u5BC6\u5EAB', ach_r03_reward: '+5% 每秒\u{1F6F8}', ach_r04: '\u767E\u842C\u6EF2\u900F', ach_r04_reward: '+10% 每秒\u{1F6F8}',
  ach_r05: '\u5104\u5143\u7279\u5DE5', ach_r05_reward: '+10% 每秒\u{1F6F8}', ach_r06: '\u5146\u5143\u884C\u52D5', ach_r06_reward: '+15% 每秒\u{1F6F8}',
  ach_r07: '\u4EAC\u5143\u5E1D\u570B', ach_r07_reward: '+15% 每秒\u{1F6F8}', ach_r08: '\u9280\u6CB3\u6D77\u6D0B', ach_r08_reward: '+20% 每秒\u{1F6F8}',
  ach_r09: '\u5B87\u5B99\u5F7C\u7AEF', ach_r09_reward: '+20% 每秒\u{1F6F8}', ach_r10: '\u7121\u9650\u6EF2\u900F', ach_r10_reward: '+30% 每秒\u{1F6F8}',
  ach_g01: '\u9996\u4F4D\u52DF\u54E1', ach_g01_reward: '\u7DDA\u4EBA x1.5', ach_g02: '\u60C5\u5831\u7DB2\u7D61', ach_g02_reward: '\u7DDA\u4EBA x2',
  ach_g03: '\u99ED\u5165\u958B\u59CB', ach_g03_reward: '\u99ED\u5BA2 x2', ach_g04: '\u7DB2\u8DEF\u8ECD\u5718', ach_g04_reward: '\u99ED\u5BA2 x3',
  ach_g05: '\u507D\u88DD\u9054\u4EBA', ach_g05_reward: '\u507D\u88DD\u5C08\u5BB6 x2', ach_g06: '\u6D17\u8166\u7DB2\u7D61', ach_g06_reward: '\u5FC3\u9748\u63A7\u5236\u5E2B x2',
  ach_g07: '\u760B\u72C2\u79D1\u5B78', ach_g07_reward: '\u79D8\u5BC6\u5BE6\u9A57\u5BA4 x2', ach_g08: '\u5A92\u9AD4\u638C\u63A7', ach_g08_reward: '\u5A92\u9AD4\u5C0F\u7D44 x2',
  ach_g09: '\u5F71\u5B50\u5167\u95A3', ach_g09_reward: '\u5F71\u5B50\u653F\u5E9C x2', ach_g10: '\u5730\u4E0B\u5E1D\u570B', ach_g10_reward: '\u6DF1\u5C64\u57FA\u5730 x2',
  ach_g11: '\u8ECC\u9053\u7D71\u6CBB', ach_g11_reward: '\u8ECC\u9053\u7AD9 x2', ach_g12: '\u9280\u6CB3\u4E4B\u4E3B', ach_g12_reward: '全體 每秒\u{1F6F8} x2',
  ach_p01: '\u9996\u6B21\u91CD\u7D44', ach_p01_reward: '+5 \u{1F48E} \u734E\u52F5', ach_p02: '\u5FAA\u74B0\u4E4B\u5473', ach_p02_reward: '+10% \u{1F48E}',
  ach_p03: '\u8001\u7DF4\u7279\u5DE5', ach_p03_reward: '+10% \u{1F48E}', ach_p04: '\u8F49\u751F\u4E0A\u7665', ach_p04_reward: '+15% \u{1F48E}',
  ach_p05: '\u7121\u9650\u8FF4\u5708', ach_p05_reward: '+20% \u{1F48E}', ach_p06: '\u9280\u6CB3\u8A18\u61B6', ach_p06_reward: '+25% \u{1F48E}',
  ach_p07: '\u9280\u6CB3\u91CD\u7D44', ach_p07_reward: '+3 \u{1F52E}\u734E\u52F5', ach_p08: '\u7DAD\u5EA6\u4E4B\u4E3B', ach_p08_reward: '+20% \u{1F52E}',
  ach_h01: '\u65B0\u4EBA\u5831\u5230', ach_h01_reward: '\u6B61\u8FCE\u734E\u52F5 100 \u{1F6F8}', ach_h02: '1\u5C0F\u6642\u73ED', ach_h02_reward: '+5% 每秒\u{1F6F8}',
  ach_h03: '\u534A\u5929', ach_h03_reward: '+10% 每秒\u{1F6F8}', ach_h04: '24\u5C0F\u6642\u76E3\u8996', ach_h04_reward: '\u96E2\u7DDA +2\u5C0F\u6642',
  ach_h05: '3\u5929\u4EFB\u52D9', ach_h05_reward: '每秒\u{1F6F8} x1.5', ach_h06: '\u9031\u6EF2\u900F', ach_h06_reward: '每秒\u{1F6F8} x2',
  ach_s01: '\u53EF\u7591\u4EBA\u985E', ach_s01_reward: '1 \u6587\u4EF6', ach_s02: '\u4E7E\u6DE8\u958B\u59CB', ach_s02_reward: '\u7A31\u865F\uFF1A\u9B6F\u8393\u7279\u5DE5',
  ach_s03: '\u5168\u90E8\u6295\u5165', ach_s03_reward: '+10% 每秒\u{1F6F8}', ach_s04: '\u901F\u901A', ach_s04_reward: '+10 \u{1F48E} \u734E\u52F5',
  ach_s05: '\u9EC3\u91D1\u7375\u4EBA', ach_s05_reward: '\u4E8B\u4EF6\u983B\u7387 -20%', ach_s06: '\u591C\u884C\u7279\u5DE5', ach_s06_reward: '夜間 每秒\u{1F6F8} x1.5',
  ach_s07: 'F2P\u6230\u58EB', ach_s07_reward: '\u5EE3\u544A\u734E\u52F5 +30%', ach_s08: '\u6536\u85CF\u5BB6', ach_s08_reward: '每秒\u{1F6F8} x3',
  ach_a01: '\u5EE3\u544A\u65B0\u624B', ach_a01_reward: '1 \u6587\u4EF6', ach_a02: '\u5EE3\u544A\u611B\u597D\u8005', ach_a02_reward: '2 \u6587\u4EF6',
  ach_a03: '\u5EE3\u544A\u5927\u5E2B', ach_a03_reward: '\u5EE3\u544A\u734E\u52F5 +30%', ach_a04: '\u6587\u4EF6\u6536\u96C6\u8005', ach_a04_reward: '\u6587\u4EF6\u6548\u679C +20%',
  ach_a05: '\u6587\u4EF6\u5C08\u5BB6', ach_a05_reward: '\u6587\u4EF6\u6548\u679C +50%',
  ach_c01: '\u9023\u64CA\u958B\u59CB', ach_c01_reward: '+0.3\u79D2 \u9023\u64CA', ach_c02: '\u7BC0\u594F\u611F', ach_c02_reward: '+0.1 \u9023\u64CA\u500D\u7387',
  ach_c03: '\u9EC3\u91D1\u65B0\u624B', ach_c03_reward: '\u4E8B\u4EF6\u734E\u52F5 +10%', ach_c04: '\u9EC3\u91D1\u6536\u96C6\u8005', ach_c04_reward: '\u4E8B\u4EF6\u983B\u7387 -10%',
  ach_c05: '\u65E5\u5E38\u72C2\u71B1', ach_c05_reward: '\u4EFB\u52D9\u734E\u52F5 +50%',
  golden_intel_leak: '\u60C5\u5831\u6D29\u6F0F!', golden_agent_frenzy: '\u7279\u5DE5\u72C2\u6F6E!', golden_money_launder: '\u8CC7\u91D1\u6E05\u6D17!',
  golden_facility_boost: '\u8A2D\u65BD\u8D85\u8F09!', golden_supply_drop: '\u9280\u6CB3\u88DC\u7D66!', golden_touch: '\u9EDE\u64CA!',
  golden_ad_double: '\u770B\u5EE3\u544A\u7372\u5F97 2\u500D',
  offline_title: '\u96E2\u7DDA\u5831\u544A', offline_elapsed: '\u7D93\u904E\u6642\u9593', offline_earned: '\u7372\u5F97 \u{1F6F8}',
  offline_cap: '\u6700\u9AD8 {h}\u5C0F\u6642\u9069\u7528', offline_claim: '\u9818\u53D6', offline_double: '\u770B\u5EE3\u544A\u7372\u5F97 2\u500D ({amount})',
  offline_hours: '{h}\u5C0F\u6642 {m}\u5206',
  settings_title: '\u8A2D\u5B9A', settings_bgm: 'BGM', settings_sfx: '\u97F3\u6548', settings_lang: '\u8A9E\u8A00',
  settings_reset: '\u91CD\u7F6E\u904A\u6232', settings_reset_confirm: '\u522A\u9664\u6240\u6709\u9032\u5EA6\u91CD\u65B0\u958B\u59CB\uFF1F',
  settings_stats: '\u7D71\u8A08', settings_total_ip: '\u7E3D\u7372\u5F97 \u{1F6F8}', settings_total_taps: '\u7E3D\u9EDE\u64CA\u6578',
  settings_total_prestiges: '\u7E3D\u8F49\u751F\u6578', settings_play_time: '\u7E3D\u904A\u73A9\u6642\u9593', settings_docs_shop: '\u6A5F\u5BC6\u6587\u4EF6\u5546\u5E97',
  doc_shop_title: '\u6A5F\u5BC6\u6587\u4EF6\u5546\u5E97',
  doc_ip_boost: '自動收益加速', doc_ip_boost_desc: '30秒內每秒🛸產量2倍',
  doc_mega_tap: '強化點擊訓練', doc_mega_tap_desc: '30秒內點擊收益3倍',
  doc_auto_click: '自動滲透裝置', doc_auto_click_desc: '30秒內每秒自動點擊10次',
  doc_instant_golden: '緊急黃金召喚', doc_instant_golden_desc: '立即觸發黃金事件',
  doc_timeskip: '時間加速器', doc_timeskip_desc: '立即獲得2小時🛸收益',
  doc_prestige_boost: '銀河增幅器', doc_prestige_boost_desc: '下次重生時💎獲取量2倍',
  doc_prestige_boost_active: '下次重生時💎x2 待機中', doc_prestige_boost_active_badge: '✅ 待機中',
  ad_offline_double: '\u96E2\u7DDA\u734E\u52F5\u52A0\u500D', ad_cps_boost: '\u6BCF\u79D2\u6536\u5165 x10 \u589E\u76CA (15\u79D2)',
  ad_prestige_bonus: '\u8F49\u751F \u{1F48E} +50%', ad_timeskip: '\u6642\u9593\u8DF3\u8E8D (2\u5C0F\u6642)', ad_free_docs: '\u514D\u8CBB\u6587\u4EF6',
  ad_golden_double: '\u9EC3\u91D1\u734E\u52F5\u52A0\u500D', ad_start_boost: '\u65B0\u624B\u589E\u76CA\u5305',
  ad_watching: '\u5EE3\u544A\u8F09\u5165\u4E2D...', ad_cooldown: '{t} \u5F8C\u53EF\u7528',
  settings_sfx_test: '\u6E2C\u8A66\u97F3\u6548', settings_sound_reset: '\u91CD\u7F6E', settings_sound_reset_done: '\u97F3\u6548\u5DF2\u91CD\u7F6E',
  num_k: '\u842C', num_m: '\u5104', num_b: '\u5146', num_t: '\u4EAC', num_qa: '\u5793',
  num_qi: '\u25CB', num_sx: '\u79ED', num_sp: '\u7A63', num_oc: '\u6E9D', num_no: '\u6B63', num_dc: '\u8F09',
  mission_title: '\u6BCF\u65E5\u4EFB\u52D9',
  mission_claim: '\u9818\u53D6',
  mission_all_complete: '\u5168\u90E8\u5B8C\u6210\u734E\u52F5\uFF01',
  mission_clear_label: '\u4EFB\u52D9',
  mission_all_clear_label: '\u5168\u90E8\u5B8C\u6210',
  ach_unlock_label: '\u6210\u5C31',
  mission_diff_easy: '\u7C21\u55AE',
  mission_diff_normal: '\u666E\u901A',
  mission_diff_hard: '\u56F0\u96E3',
  mission_tap_100: '\u8F15\u8F15\u9EDE\u64CA',
  mission_tap_100_desc: '\u9EDE\u64CA 100 \u6B21',
  mission_tap_300: '\u6696\u624B\u904B\u52D5',
  mission_tap_300_desc: '\u9EDE\u64CA 300 \u6B21',
  mission_buy_5: '\u5C0F\u578B\u62DB\u52DF',
  mission_buy_5_desc: '\u8CFC\u8CB7 5 \u500B\u751F\u7522\u8005',
  mission_combo_10: '\u9023\u64CA\u5165\u9580',
  mission_combo_10_desc: '\u9054\u5230 10 \u9023\u64CA',
  mission_golden_1: '\u5E78\u904B\u6355\u7372',
  mission_golden_1_desc: '\u6355\u6349 1 \u500B\u9EC3\u91D1\u4E8B\u4EF6',
  mission_tap_1000: '\u91CD\u64CA\u624B',
  mission_tap_1000_desc: '\u9EDE\u64CA 1,000 \u6B21',
  mission_buy_20: '\u5C0F\u968A\u5EFA\u9020\u8005',
  mission_buy_20_desc: '\u8CFC\u8CB7 20 \u500B\u751F\u7522\u8005',
  mission_combo_50: '\u9023\u64CA\u9054\u4EBA',
  mission_combo_50_desc: '\u9054\u5230 50 \u9023\u64CA',
  mission_golden_3: '\u6DD8\u91D1\u71B1',
  mission_golden_3_desc: '\u6355\u6349 3 \u500B\u9EC3\u91D1\u4E8B\u4EF6',
  mission_earn_1m: '\u767E\u842C\u884C\u52D5',
  mission_earn_1m_desc: '\u8CFA\u53D6 1M \u{1F6F8}',
  mission_tap_5000: '\u9EDE\u64CA\u6A5F\u5668',
  mission_tap_5000_desc: '\u9EDE\u64CA 5,000 \u6B21',
  mission_buy_50: '\u8ECD\u968A\u5EFA\u9020\u8005',
  mission_buy_50_desc: '\u8CFC\u8CB7 50 \u500B\u751F\u7522\u8005',
  mission_combo_100: '\u9023\u64CA\u4E4B\u795E',
  mission_combo_100_desc: '\u9054\u5230 100 \u9023\u64CA',
  mission_golden_5: '\u9EC3\u91D1\u5927\u5E2B',
  mission_golden_5_desc: '\u6355\u6349 5 \u500B\u9EC3\u91D1\u4E8B\u4EF6',
  mission_earn_1b: '\u5104\u5143\u7279\u5DE5',
  mission_earn_1b_desc: '\u8CFA\u53D6 1B \u{1F6F8}',
  mission_tap_200: '快手',
  mission_tap_200_desc: '點擊200次',
  mission_buy_3: '首批招募',
  mission_buy_3_desc: '購買3個生產者',
  mission_combo_15: '連擊入門',
  mission_combo_15_desc: '達成15連擊',
  mission_earn_10k: '零用錢',
  mission_earn_10k_desc: '賺取10K 🛸',
  mission_earn_100k: '募資者',
  mission_earn_100k_desc: '賺取100K 🛸',
  mission_tap_500: '穩定點擊',
  mission_tap_500_desc: '點擊500次',
  mission_tap_700: '不屈不撓',
  mission_tap_700_desc: '點擊700次',
  mission_buy_10: '隊長',
  mission_buy_10_desc: '購買10個生產者',
  mission_combo_30: '連擊鏈',
  mission_combo_30_desc: '達成30連擊',
  mission_golden_2: '雙倍黃金',
  mission_golden_2_desc: '觸碰2次黃金事件',
  mission_tap_3000: '點擊戰士',
  mission_tap_3000_desc: '點擊3,000次',
  mission_buy_30: '大隊',
  mission_buy_30_desc: '購買30個生產者',
  mission_combo_75: '連擊精英',
  mission_combo_75_desc: '達成75連擊',
  mission_golden_4: '黃金獵人',
  mission_golden_4_desc: '觸碰4次黃金事件',
  mission_earn_10m: '大亨',
  mission_earn_10m_desc: '賺取10M 🛸',

  // Conquest
  cq_title: '\u4E16\u754C\u5F81\u670D',
  cq_progress: '\u5DF2\u5F81\u670D',
  cq_infiltration_power: '滲透力',
  cq_active_conquest: '滲透中',
  cq_infiltration_progress: '滲透進度',
  cq_time_remaining: '預估完成時間',
  cq_start_infiltration: '開始滲透',
  cq_stop_infiltration: '停止滲透',
  cq_no_power_hint: '雇用特工來產生滲透力',
  cq_locked: '\u9396\u5B9A',
  cq_available: '\u53EF\u5165\u4FB5',
  cq_conquered: '\u5DF2\u5F81\u670D',
  cq_popup_title: '征服完成！',
  cq_popup_desc: '已被征服！建造設施以變得更強大。',
  cq_back: '\u8FD4\u56DE',
  cq_invest_title: '\u6295\u8CC7\u{1F6F8}\u9032\u884C\u5F81\u670D',
  cq_current_ip: '\u7576\u524D\u{1F6F8}',
  cq_facilities: '\u8A2D\u65BD',
  cq_build: '\u5EFA\u9020',
  cq_upgrade: '\u5347\u7D1A',
  cq_next_level: '\u4E0B\u4E00\u7D1A',
  cq_counter_intel_title: '\u53CD\u9593\u8ADE\u8B66\u5831\uFF01',
  cq_counter_intel_text: '\u60A8\u5728{country}\u7684\u6EF2\u900F\u5DF2\u88AB\u767C\u73FE\uFF01\u9032\u5EA6\u5C07\u6703\u6E1B\u5C11\u3002',
  cq_defend_ad: '\u770B\u5EE3\u544A\u9632\u79A6',
  cq_accept_loss: '\u63A5\u53D7\u640D\u5931',
  cq_ending_title: '\u5730\u7403\u5F81\u670D\u5B8C\u6210\uFF01',
  cq_ending_text: '\u722C\u87F2\u4EBA\u9670\u8B00\u5DF2\u5B8C\u6210\u3002\u6240\u6709\u570B\u5BB6\u90FD\u5411\u6697\u5F71\u5E1D\u570B\u81E3\u670D\u3002',
  cq_ending_time: '\u904A\u6232\u6642\u9593',
  cq_ending_prestiges: '\u8F49\u751F\u6B21\u6578',
  cq_ending_total_ip: '\u7E3D\u{1F6F8}',
  cq_ending_taps: '\u7E3D\u9EDE\u64CA\u6578',
  cq_ending_continue: '\u7E7C\u7E8C\u904A\u6232',
  cq_egypt: '\u57C3\u53CA', cq_egypt_desc: '\u91D1\u5B57\u5854\u53E4\u4EE3\u57FA\u5730',
  cq_brazil: '\u5DF4\u897F', cq_brazil_desc: '\u4E9E\u99AC\u905C\u53E2\u6797\u85CF\u8EAB\u8655',
  cq_india: '\u5370\u5EA6', cq_india_desc: '\u90A3\u8FE6\u4FE1\u4EF0\u6EF2\u900F',
  cq_australia: '\u6FB3\u6D32', cq_australia_desc: '\u6C99\u6F20\u5730\u4E0B\u789E\u5821',
  cq_japan: '\u65E5\u672C', cq_japan_desc: '\u6280\u8853\u7ACA\u53D6\u884C\u52D5',
  cq_korea: '\u97D3\u570B', cq_korea_desc: 'NIS\u7DB2\u8DEF\u9632\u79A6\u7A81\u7834',
  cq_uk: '\u82F1\u570B', cq_uk_desc: 'MI5/MI6\u7687\u5BA4\u6EF2\u900F',
  cq_russia: '\u4FC4\u7F85\u65AF', cq_russia_desc: 'FSB\u897F\u4F2F\u5229\u4E9E\u884C\u52D5',
  cq_china: '\u4E2D\u570B', cq_china_desc: '\u4E16\u754C\u6700\u5F37\u76E3\u63A7\u7DB2',
  cq_usa: '\u7F8E\u570B', cq_usa_desc: 'CIA/NSA\u6700\u7D42Boss',
  fac_pyramid_vault: '\u91D1\u5B57\u5854\u91D1\u5EAB', fac_pyramid_vault_d: '每級 每秒\u{1F6F8} +5%',
  fac_nile_network: '\u5C3C\u7F85\u6CB3\u7DB2\u8DEF', fac_nile_network_d: '\u6BCF\u7D1A\u96E2\u7DDA +5%',
  fac_ancient_lab: '\u53E4\u4EE3\u5BE6\u9A57\u5BA4', fac_ancient_lab_d: '\u6BCF\u7D1ATAP +10%',
  fac_amazon_hideout: '\u4E9E\u99AC\u905C\u85CF\u8EAB\u8655', fac_amazon_hideout_d: '\u6BCF\u7D1A\u751F\u7522\u8005\u6298\u6263 +2%',
  fac_samba_broadcast: '\u68EE\u5DF4\u5EE3\u64AD\u7AD9', fac_samba_broadcast_d: '每級 每秒\u{1F6F8} +8%',
  fac_jungle_lab: '\u53E2\u6797\u5BE6\u9A57\u5BA4', fac_jungle_lab_d: '\u6BCF\u7D1A\u9EC3\u91D1\u4E8B\u4EF6 +5%',
  fac_naga_temple: '\u90A3\u8FE6\u795E\u6BBF', fac_naga_temple_d: '\u6BCF\u7D1A\u{1F48E} +5%',
  fac_bollywood_studio: '\u5BF6\u840A\u5862\u5DE5\u4F5C\u5BA4', fac_bollywood_studio_d: '\u6BCF\u7D1A\u96E2\u7DDA +8%',
  fac_caste_network: '\u7A2E\u59D3\u7DB2\u8DEF', fac_caste_network_d: '每級 每秒\u{1F6F8} +12%',
  fac_desert_bunker: '\u6C99\u6F20\u789E\u5821', fac_desert_bunker_d: '\u6BCF\u7D1ATAP +15%',
  fac_ayers_signal: '\u827E\u723E\u65AF\u4FE1\u865F', fac_ayers_signal_d: '\u6BCF\u7D1A\u9EC3\u91D1\u4E8B\u4EF6 +8%',
  fac_outback_base: '\u5167\u9678\u57FA\u5730', fac_outback_base_d: '每級 每秒\u{1F6F8} +15%',
  fac_akiba_ai: '\u79CB\u8449\u539FAI', fac_akiba_ai_d: '每級 每秒\u{1F6F8} +20%',
  fac_ninja_intel: '\u5FCD\u8005\u60C5\u5831\u90E8', fac_ninja_intel_d: '\u6BCF\u7D1A\u751F\u7522\u8005\u6298\u6263 +3%',
  fac_tokyo_tower: '\u6771\u4EAC\u9435\u5854', fac_tokyo_tower_d: '\u6BCF\u7D1A\u{1F48E} +8%',
  fac_gangnam_hq: '\u6C5F\u5357\u7E3D\u90E8', fac_gangnam_hq_d: '每級 每秒\u{1F6F8} +25%',
  fac_cyber_command: '\u7DB2\u8DEF\u53F8\u4EE4\u90E8', fac_cyber_command_d: '\u6BCF\u7D1ATAP +25%',
  fac_kpop_brainwash: 'K-Pop\u6D17\u8166\u6A5F', fac_kpop_brainwash_d: '\u6BCF\u7D1A\u{1F48E} +10%',
  fac_royal_infiltrate: '\u7687\u5BA4\u6EF2\u900F', fac_royal_infiltrate_d: '每級 每秒\u{1F6F8} +30%',
  fac_london_tower: '\u502B\u6566\u5854', fac_london_tower_d: '\u6BCF\u7D1A\u96E2\u7DDA +15%',
  fac_mi6_double: 'MI6\u96D9\u9762\u9593\u8ADE', fac_mi6_double_d: '\u6BCF\u7D1A\u9EC3\u91D1\u4E8B\u4EF6 +12%',
  fac_siberia_base: '\u897F\u4F2F\u5229\u4E9E\u57FA\u5730', fac_siberia_base_d: '每級 每秒\u{1F6F8} +40%',
  fac_kgb_remnant: 'KGB\u6B98\u9EE8', fac_kgb_remnant_d: '\u6BCF\u7D1A\u751F\u7522\u8005\u6298\u6263 +5%',
  fac_nuke_bunker: '\u6838\u5F48\u789E\u5821', fac_nuke_bunker_d: '\u6BCF\u7D1ATAP +40%',
  fac_great_wall: '\u9632\u706B\u9577\u57CE', fac_great_wall_d: '每級 每秒\u{1F6F8} +50%',
  fac_shenzhen_factory: '\u6DF1\u5733\u5DE5\u5EE0', fac_shenzhen_factory_d: '\u6BCF\u7D1A\u751F\u7522\u8005\u6298\u6263 +8%',
  fac_panda_spy: '\u718A\u8C93\u9593\u8ADE\u7DB2', fac_panda_spy_d: '\u6BCF\u7D1A\u9EC3\u91D1\u4E8B\u4EF6 +20%',
  fac_area51: '51\u5340', fac_area51_d: '每級 每秒\u{1F6F8} +80%',
  fac_pentagon: '\u4E94\u89D2\u5927\u5EC8', fac_pentagon_d: '\u6BCF\u7D1ATAP +80%',
  fac_wall_street: '\u83EF\u723E\u8857', fac_wall_street_d: '\u6BCF\u7D1A\u{1F48E} +25%',

  buy: '\u8CFC\u8CB7', max: '\u6700\u5927', level: 'Lv.', locked: '\u9396\u5B9A', unlocked: '\u89E3\u9396',
  upgrade_locked_prev: '\u8ACB\u5148\u5B78\u7FD2\u524D\u4E00\u500B\u5347\u7D1A',
  condition: '\u689D\u4EF6', cost: '\u8CBB\u7528', owned: '\u64C1\u6709', effect: '\u6548\u679C', reward: '\u734E\u52F5',
  close: '\u95DC\u9589', confirm: '\u78BA\u8A8D', cancel: '\u53D6\u6D88',

  // Conquest achievements
  ach_filter_conquest: '征服',
  ach_q01: '首次征服', ach_q01_reward: '每秒\u{1F6F8} +10%',
  ach_q02: '三國征服', ach_q02_reward: 'TAP +10%',
  ach_q03: '半壁江山', ach_q03_reward: '💎獲取 +15%',
  ach_q04: '七面旗幟', ach_q04_reward: '離線效率 +20%',
  ach_q05: '世界征服者', ach_q05_reward: '全體 每秒\u{1F6F8} x3',
  ach_q06: '設施大師', ach_q06_reward: '全體 每秒\u{1F6F8} x2',
  milestone_next: '下一個',
  settings_conquest: '征服進度',

  // Currency info
  currency_ip_name: '滲透點數 (IP)',
  currency_ip_earn: '點擊、特工自動生產、離線收入和廣告獎勵',
  currency_ip_use: '僱用特工、購買升級、投資國家征服',
  currency_gc_name: '銀河信用 (GC)',
  currency_gc_earn: '重生（組織重組）時根據累計IP獲得',
  currency_gc_use: '購買重生升級（生產倍率、離線效率等）',
  currency_cores_name: '銀河核心',
  currency_cores_earn: '二次重生（銀河重組）時根據累計GC獲得',
  currency_cores_use: '購買二次重生升級（永久增益、自動化等）',
  currency_docs_name: '機密文件',
  currency_docs_earn: '完成每日任務、觀看廣告或解鎖成就',
  currency_docs_use: '在文件商店（任務標籤）購買強力增益道具',
  currency_how_earn: '獲取方式',
  currency_how_use: '使用方式',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: '滲透精通',
  pup_infiltration_mastery_desc: '每級全體滲透力 +50%（最高 +500%）',
  pup_agent_network: '特工網路',
  pup_agent_network_desc: '每級每100名特工滲透力 +5%',
  pup_quick_infiltration: '連鎖滲透',
  pup_quick_infiltration_desc: '征服國家時下個國家進度 +10%/Lv',
  pup_critical_chance: '致命一擊訓練',
  pup_critical_chance_desc: '點擊暴擊率 +3%/Lv（基礎10%，上限50%）',
  pup_critical_damage: '致命一擊強化',
  pup_critical_damage_desc: '暴擊傷害 +1x/Lv（基礎 x3）',

  // Special upgrades - conquest
  special_spy_master: '間諜大師',
  special_spy_master_desc: '全體滲透力 x2',

  ad_income_x5: '獲得30分鐘收入',
  ad_income_x5_desc: '觀看廣告即可立即獲得\n{amount} 🛸（30分鐘的收入）！',
  ad_tap_x10: '點擊 x10 (10秒)',
  ad_tap_x10_desc: '觀看廣告後\n10秒內點擊收入提升10倍！',
  ad_free_docs_desc: '觀看廣告即可\n免費獲得1份機密文件 📜！',
  ad_prestige_desc: '觀看廣告後\n15秒內收入提升10倍！',
  cq_tutorial_title: '🌍 世界征服指南',
  cq_tutorial_text: '征服國家後可以建造<b>設施</b>！\n升級設施可獲得永久加成\n如<b>每秒收入、點擊收入、離線收入</b>等。\n\n雇用探員可提升滲透力。',
  rank_promote: '晉升',
  rank_promoted: '晉升完成！',

  // Boss events
  boss_resistance_captain: '抵抗軍隊長',
  boss_resistance_captain_desc: '人類民兵領袖，身經百戰的戰士',
  boss_cia_agent: 'CIA探員',
  boss_cia_agent_desc: '持有機密情報的秘密特工',
  boss_mib_investigator: 'MIB調查員',
  boss_mib_investigator_desc: 'Men In Black外勤探員',
  boss_un_inspector: '聯合國調查員',
  boss_un_inspector_desc: '國際陰謀追蹤者',
  boss_whistleblower: '吹哨者',
  boss_whistleblower_desc: '握有證據的叛逃者',
  boss_journalist: '調查記者',
  boss_journalist_desc: '手持攝影機的執著真相追求者',
  boss_truth_seeker: '真相追尋者',
  boss_truth_seeker_desc: '超自然現象研究員',
  boss_galactic_guardian: '銀河守護者',
  boss_galactic_guardian_desc: '宇宙法則的執行者',

  boss_alert: '威脅偵測！',
  boss_alert_desc: '敵人出現了！點擊攻擊！',
  boss_hp: 'HP',
  boss_tap_attack: '點擊攻擊！',
  boss_double_damage: '2x傷害 (30秒)',
  boss_eliminated: '消滅完成！',
  boss_eliminated_desc: '{name}已被擊敗！',
  boss_reward_ip: '+{amount} IP',
  boss_reward_docs: '+{amount} Docs',
  boss_reward_gc: '+{amount} GC',
  boss_reward_boost: 'CPS x3 ({seconds}秒)',
  boss_claim: '領取獎勵',
  boss_claim_double: '2倍獎勵',
  boss_escaped: '逃跑了！',
  boss_escaped_desc: '目標逃走了...',
  boss_revive: '重新挑戰 (+20秒)',
  boss_phase2: '狂暴化！',
  boss_streak: '連續擊殺: {n}',
  boss_time_remaining: '時間',
  boss_double_damage_active: '2x傷害生效中！',

  // Agent collection
  tab_agent: '特工',
  agent_collection_title: '特工收藏',
  agent_equipped: '已裝備',
  agent_empty_slot: '空位',
  agent_obtained: '獲得特工！',
  agent_equip: '裝備',
  agent_unequip: '卸下',
  agent_locked: '???',
  agent_count: 'x{n}',
  agent_tutorial_title: '特工收集指南',
  agent_tutorial_text: '擊敗<b>首領</b>來收集特工卡片！<br><br>每位特工都有獨特的被動加成。<br>點擊卡片來裝備特工。<br><br>稀有度越高 = 效果越強。<br>轉生可解鎖更多裝備欄位。',

  // Agent effect descriptions
  agent_effect_cps_pct: 'CPS {n}',
  agent_effect_tap_pct: 'TAP {n}',
  agent_effect_conquest_speed: '征服速度 {n}',
  agent_effect_boss_damage: 'Boss傷害 {n}',
  agent_effect_golden_chance: '黃金事件 {n}',
  agent_effect_offline_pct: '離線收入 {n}',
  agent_effect_docs_rate: '文件比率 {n}',
  agent_effect_gc_pct: 'GC獲取 {n}',
  agent_effect_boss_spawn_reduce: 'Boss出現 -{n}',
  agent_effect_prestige_gc_bonus: '威望GC {n}',
  agent_effect_faction_favor: '勢力好感 {n}',

  // Agent names & descriptions (25 agents)
  // Common (10)
  agent_field_spy: '外勤間諜',
  agent_field_spy_desc: '外勤情報提升IP產量+8%',
  agent_code_cracker: '密碼破解者',
  agent_code_cracker_desc: '解密技術提升點擊力量+10%',
  agent_shadow_runner: '暗影跑者',
  agent_shadow_runner_desc: '隱匿專長提升征服速度+10%',
  agent_data_miner: '數據挖掘者',
  agent_data_miner_desc: '數據採集提升離線收入+15%',
  agent_lookout: '瞭望員',
  agent_lookout_desc: '敏銳目光提升黃金事件機率+10%',
  agent_doc_thief: '文件竊賊',
  agent_doc_thief_desc: '文件竊取提升文件獲取量+15%',
  agent_network_bot: '網路機器人',
  agent_network_bot_desc: '自動化網路提升CPS+10%',
  agent_safe_cracker: '保險箱破解者',
  agent_safe_cracker_desc: '保險箱技術提升點擊力量+12%',
  agent_recruit: '新兵',
  agent_recruit_desc: '新戰士提升Boss傷害+10%',
  agent_comm_officer: '通訊官',
  agent_comm_officer_desc: '通訊技術提升勢力好感+10%',

  // Rare (8)
  agent_infiltration_ace: '滲透王牌',
  agent_infiltration_ace_desc: '精英滲透提升CPS+20%',
  agent_mind_bender: '心靈操控者',
  agent_mind_bender_desc: '精神力量提升征服速度+25%',
  agent_vault_raider: '金庫突襲者',
  agent_vault_raider_desc: '金庫專精提升GC獲取+20%',
  agent_signal_jammer: '訊號干擾者',
  agent_signal_jammer_desc: '干擾縮短Boss出現間隔-15%',
  agent_double_agent: '雙面間諜',
  agent_double_agent_desc: '雙重忠誠提升離線收入+30%',
  agent_hive_mind: '蜂巢意識',
  agent_hive_mind_desc: '集體意識提升文件比率+25%',
  agent_boss_hunter: 'Boss獵手',
  agent_boss_hunter_desc: '專業追蹤提升Boss傷害+25%',
  agent_faction_liaison: '勢力聯絡官',
  agent_faction_liaison_desc: '外交關係提升勢力好感+25%',

  // Epic (5)
  agent_reptilian_elite: '蜥蜴人精英',
  agent_reptilian_elite_desc: '精英戰士提升CPS+35%',
  agent_galaxy_commander: '銀河指揮官',
  agent_galaxy_commander_desc: '銀河權威提升GC獲取+40%',
  agent_dark_secretary: '暗黑秘書長',
  agent_dark_secretary_desc: '暗影官僚提升威望GC+20%',
  agent_omega_operative: '歐米茄特工',
  agent_omega_operative_desc: '終極戰士提升Boss傷害+50%',
  agent_shapeshifter: '變形者',
  agent_shapeshifter_desc: '變形大師提升點擊力量+40%',

  // Legendary (2)
  agent_the_overlord: '至高霸主',
  agent_the_overlord_desc: '最高統帥提升全CPS+50%',
  agent_grand_architect: '宏偉建築師',
  agent_grand_architect_desc: '宇宙規劃者提升征服速度+60%',
  // Faction system
  faction_status_title: '勢力狀態',
  faction_favorability: '好感度',
  faction_tier: '等級 {n}',

  // Faction event popup
  faction_event_help: '幫助',
  faction_event_ignore: '忽略',
  faction_event_timer: '剩餘{seconds}秒',
  faction_event_reward: '+{favor} {faction} 好感度, -{loss} {target} 好感度',
  faction_event_ip_reward: '+{amount} IP 獎勵',
  faction_event_ad_bonus: '觀看廣告: +{n} {faction} 好感度',

  // Faction names
  faction_illuminati: '光明會',
  faction_illuminati_desc: '在暗處操控世界的人類秘密統治者',
  faction_grey: '灰色外星人',
  faction_grey_desc: '分享科技的外星物種',
  faction_mib: 'MIB抵抗軍',
  faction_mib_desc: '對抗外星人影響的人類秘密組織',

  // Faction bonus descriptions
  faction_illuminati_bonus1: 'CPS +10%',
  faction_illuminati_bonus2: 'CPS +15%',
  faction_illuminati_bonus3: '征服速度 +20%',
  faction_grey_bonus1: '點擊 +15%',
  faction_grey_bonus2: '點擊 +20%',
  faction_grey_bonus3: '黃金餅乾 +25%',
  faction_mib_bonus1: 'Boss傷害 +20%',
  faction_mib_bonus2: '離線收入 +15%',
  faction_mib_bonus3: 'Boss出現 -15%',

  // Event titles and descriptions
  event_illu_decode_title: '機密攔截',
  event_illu_decode_desc: '光明會正在攔截政府機密檔案。要幫忙解碼嗎？',
  event_illu_stock_title: '市場操縱',
  event_illu_stock_desc: '光明會想操縱全球股市。要提供內線情報嗎？',
  event_illu_surveillance_title: '監控網路',
  event_illu_surveillance_desc: '光明會正在建造秘密監控網路。要協助建設嗎？',
  event_illu_meeting_title: '秘密峰會',
  event_illu_meeting_desc: '世界領袖集會中的光明會秘密會議。要提供安全保護嗎？',
  event_illu_bribe_title: '外星人外交',
  event_illu_bribe_desc: '光明會想賄賂一位外星外交官。要負責遞送嗎？',

  event_grey_experiment_title: '人體研究',
  event_grey_experiment_desc: '灰色外星人正在對人類進行實驗。要看守實驗室嗎？',
  event_grey_mindcontrol_title: '心靈控制裝置',
  event_grey_mindcontrol_desc: '灰色外星人想在城市安裝心靈控制裝置。要幫忙建造嗎？',
  event_grey_crash_title: '墜毀回收',
  event_grey_crash_desc: '一架灰色偵察船在沙漠墜毀。要幫忙救回組員嗎？',
  event_grey_terraform_title: '秘密改造地形',
  event_grey_terraform_desc: '灰色外星人正在秘密改造一座島嶼。要提供資源嗎？',
  event_grey_hack_title: '衛星入侵',
  event_grey_hack_desc: '灰色外星人想入侵地球衛星網路。要提供存取代碼嗎？',

  event_mib_raid_title: '外星前哨突襲',
  event_mib_raid_desc: 'MIB正在計劃突襲一個外星前哨站。要加入攻擊嗎？',
  event_mib_safehouse_title: '安全屋發現',
  event_mib_safehouse_desc: 'MIB發現了一個隱藏的光明會安全屋。要幫忙突襲嗎？',
  event_mib_weapons_title: '武器研發',
  event_mib_weapons_desc: 'MIB正在研發反外星武器。要提供稀有材料嗎？',
  event_mib_evacuate_title: '平民撤離',
  event_mib_evacuate_desc: 'MIB需要從外星攻擊區域撤離平民。要幫忙嗎？',
  event_mib_expose_title: '貪腐曝光',
  event_mib_expose_desc: 'MIB想向大眾揭露光明會的貪腐行為。要洩露文件嗎？',

  // Shadow Contact (mid-game ad choices)
  sc_title: '暗影接頭',
  sc_accept: '接受交易',
  sc_decline: '拒絕',
  sc_offer_intel: '情報報告',
  sc_offer_intel_desc: '深層臥底提供價值 {amount} 🛸 的機密情報',
  sc_offer_serum: '實驗血清',
  sc_offer_serum_desc: '一種外星實驗樣本，可在30秒內將點擊力量提升10倍',
  sc_offer_tech: '黑市科技',
  sc_offer_tech_desc: '竊取的外星技術，可在30秒內將收入提升10倍',
  sc_offer_docs: '機密文件庫',
  sc_offer_docs_desc: '藏有3份機密文件的秘密儲藏處 📜',
  boss_warning: '警告',
  boss_warning_sub: '強大的敵人正在逼近...',
  boss_tutorial_title: 'Boss戰！',
  boss_tutorial_text: 'Boss出現了！快速點擊造成傷害！<br><br>擊敗Boss可獲得<b>IP、文件、特工卡</b>！<br>觀看廣告可獲得<b>2倍傷害</b>加成。',
  // === Infiltration Run (generated) ===
  tab_infiltration: "Infiltrate",
  infil_eyebrow: "INFILTRATION OPS",
  infil_title: "Infiltration Run",
  infil_subtitle: "Slip in, climb the ranks, get out clean.",
  infil_tutorial_note: "First run: learn the ropes. Chasing the top rank too hard gets you caught.",
  infil_agent_stats: "Agent Stats",
  infil_highest_career: "Best Career",
  infil_total_runs: "Total Runs",
  infil_total_success: "Successes",
  infil_tradeoff_hint: "Safe = small reward, low rank. Greedy = high detection, high risk. Weigh every choice.",
  infil_start: "Start Infiltration",
  infil_start_tutorial: "Start Tutorial Run",
  infil_cooldown: "Cooldown",
  infil_cancel: "Cancel",
  infil_detection: "Detection",
  infil_step: "Event",
  infil_difficulty: "Diff",
  infil_selecting: "Selecting",
  infil_choice_success: "SUCCESS",
  infil_choice_fail: "FAILED",
  infil_roll: "Roll",
  infil_next: "Next",
  infil_to_extraction: "To Extraction",
  infil_extraction_cat: "FINAL STEP",
  infil_extraction_title: "Extraction",
  infil_extraction_desc: "All events cleared. Slip out now — the lower your detection, the safer.",
  infil_attempt_extraction: "Attempt Extraction",
  infil_final_chance: "Extraction Chance",
  infil_result_success: "INFILTRATION SUCCESS",
  infil_result_fail: "CAUGHT",
  infil_result_success_sub: "You slipped out and secured a cover career.",
  infil_result_fail_sub: "Security caught you. Nothing gained this time.",
  infil_docs: "Docs",
  infil_cleared: "Cleared",
  infil_career_earned: "Career Secured",
  infil_fail_note: "No reward. A short cooldown before the next run.",
  infil_retry_ad: "Watch Ad: Second Chance",
  infil_retry_title: "Second Chance",
  infil_retry_desc: "Watch a short ad to lower your detection and retry the extraction once.",
  infil_retry_confirm: "Watch Ad",
  infil_close: "Close",
  infil_stat_disguise: "Disguise",
  infil_stat_combat: "Combat",
  infil_stat_hacking: "Hacking",
  infil_stat_charisma: "Charisma",
  infil_stat_none: "No Check",
  infil_tag_safe: "SAFE",
  infil_tag_risky: "RISKY",
  infil_tag_aggressive: "ALL-IN",
  infil_career_cleaner: "Cleaner",
  infil_career_guard: "Guard",
  infil_career_clerk: "Clerk",
  infil_career_manager: "Manager",
  infil_career_executive: "Executive",
  infil_career_director: "Director",
  infil_career_warrior: "Warrior",
  infil_career_none: "None",
  infil_ev_patrol_cat: "Infiltration Case / Corporate State",
  infil_ev_patrol_title: "Patrol Approaching",
  infil_ev_patrol_desc: "A security patrol is heading straight for you. How do you react?",
  infil_ch_patrol_a_label: "Wait in the shadows",
  infil_ch_patrol_a_desc: "Hold your breath until they pass. Safe, but you lose time.",
  infil_ch_patrol_b_label: "Greet them as staff",
  infil_ch_patrol_b_desc: "Nod politely in your cover identity and walk past.",
  infil_ch_patrol_c_label: "Take them down",
  infil_ch_patrol_c_desc: "Ambush the patrol and force through. Big reward, big risk.",
  infil_ev_security_check_cat: "Infiltration Case / Corporate State",
  infil_ev_security_check_title: "Security Checkpoint",
  infil_ev_security_check_desc: "A manned checkpoint blocks the corridor ahead.",
  infil_ch_security_check_a_label: "Find a side route",
  infil_ch_security_check_a_desc: "Quietly slip down an adjacent passage.",
  infil_ch_security_check_b_label: "Show forged pass",
  infil_ch_security_check_b_desc: "Present a well-made forged access pass.",
  infil_ch_security_check_c_label: "Hack the scanner",
  infil_ch_security_check_c_desc: "Breach the scanner terminal and kill the alarm.",
  infil_ev_informant_cat: "Infiltration Case / Corporate State",
  infil_ev_informant_title: "Recruit an Informant",
  infil_ev_informant_desc: "An insider might hand over classified files — for a price.",
  infil_ch_informant_a_label: "Take the anonymous tip",
  infil_ch_informant_a_desc: "Check the drop box without making contact.",
  infil_ch_informant_b_label: "Persuade the insider",
  infil_ch_informant_b_desc: "Win over the staffer with smooth talk.",
  infil_ch_informant_c_label: "Strong-arm the files",
  infil_ch_informant_c_desc: "Threaten them into surrendering the data.",
  infil_ev_cctv_cat: "Infiltration Case / Corporate State",
  infil_ev_cctv_title: "Bypass the CCTV",
  infil_ev_cctv_desc: "A ceiling of cameras sweeps the whole hall.",
  infil_ch_cctv_a_label: "Move through blind spots",
  infil_ch_cctv_a_desc: "Creep slowly along the camera blind spots.",
  infil_ch_cctv_b_label: "Loop the feed",
  infil_ch_cctv_b_desc: "Splice a fake loop into the surveillance feed.",
  infil_ch_cctv_c_label: "Smash the cameras",
  infil_ch_cctv_c_desc: "Wreck the cameras and rush past.",
  infil_ev_fake_id_cat: "Infiltration Case / Corporate State",
  infil_ev_fake_id_title: "ID Inspection",
  infil_ev_fake_id_desc: "Guards are checking every ID in a long queue.",
  infil_ch_fake_id_a_label: "Leave the queue",
  infil_ch_fake_id_a_desc: "Quietly drop out and find another way.",
  infil_ch_fake_id_b_label: "Present forged ID",
  infil_ch_fake_id_b_desc: "Pass the checkpoint with a crafted forgery.",
  infil_ch_fake_id_c_label: "Sweet-talk the guard",
  infil_ch_fake_id_c_desc: "Talk your way past with slick charm.",
  infil_ev_parking_cat: "Infiltration Case / Corporate State",
  infil_ev_parking_title: "Underground Parking",
  infil_ev_parking_desc: "The garage is your way in, but a guard patrols it.",
  infil_ch_parking_a_label: "Hide behind vehicles",
  infil_ch_parking_a_desc: "Tuck yourself between parked cars.",
  infil_ch_parking_b_label: "Neutralize the guard",
  infil_ch_parking_b_desc: "Silently subdue the garage guard.",
  infil_ch_parking_c_label: "Pose as valet",
  infil_ch_parking_c_desc: "Steal a valet uniform and stroll in.",
  infil_ev_server_room_cat: "Infiltration Case / Corporate State",
  infil_ev_server_room_title: "Server Room Breach",
  infil_ev_server_room_desc: "The core data sits behind a hardened server-room door.",
  infil_ch_server_room_a_label: "Crawl the vents",
  infil_ch_server_room_a_desc: "Take the narrow vents. Slow but safe.",
  infil_ch_server_room_b_label: "Seize admin access",
  infil_ch_server_room_b_desc: "Hijack admin rights to open the room.",
  infil_ch_server_room_c_label: "Force the door",
  infil_ch_server_room_c_desc: "Rip open the security door and barge in.",
  infil_ev_board_meeting_cat: "Infiltration Case / Corporate State",
  infil_ev_board_meeting_title: "Board Meeting Infiltration",
  infil_ev_board_meeting_desc: "Top executives are trading secrets behind closed doors.",
  infil_ch_board_meeting_a_label: "Eavesdrop from the hall",
  infil_ch_board_meeting_a_desc: "Listen quietly from outside the room.",
  infil_ch_board_meeting_b_label: "Pose as consultant",
  infil_ch_board_meeting_b_desc: "Blend in as an outside consultant.",
  infil_ch_board_meeting_c_label: "Storm the room",
  infil_ch_board_meeting_c_desc: "Raid the room and seize every secret. Warrior play.",
  infil_ev_reporter_cat: "Infiltration Case / Corporate State",
  infil_ev_reporter_title: "Shake the Reporter",
  infil_ev_reporter_desc: "A dogged journalist is tailing your every move.",
  infil_ch_reporter_a_label: "Blend into the crowd",
  infil_ch_reporter_a_desc: "Melt into a busy street to lose the tail.",
  infil_ch_reporter_b_label: "Change disguise",
  infil_ch_reporter_b_desc: "Swap outerwear and reverse direction.",
  infil_ch_reporter_c_label: "Feed false leads",
  infil_ch_reporter_c_desc: "Approach first and plant fake information.",
  infil_ev_party_cat: "Infiltration Case / Corporate State",
  infil_ev_party_title: "Crash the Party",
  infil_ev_party_desc: "A gala hides the people you need to reach.",
  infil_ch_party_a_label: "Carry a waiter tray",
  infil_ch_party_a_desc: "Grab an empty tray and pose as service.",
  infil_ch_party_b_label: "Pose as a guest",
  infil_ch_party_b_desc: "Mingle smoothly as an invited guest.",
  infil_ch_party_c_label: "Enter as a VIP",
  infil_ch_party_c_desc: "Dress as a VIP and stride through the front.",
  infil_ev_drone_cat: "Infiltration Case / Corporate State",
  infil_ev_drone_title: "Drone Surveillance",
  infil_ev_drone_desc: "A surveillance drone sweeps the open yard.",
  infil_ch_drone_a_label: "Wait under cover",
  infil_ch_drone_a_desc: "Hide beneath a structure until it passes.",
  infil_ch_drone_b_label: "Jam the signal",
  infil_ch_drone_b_desc: "Jam its comms and blind the drone.",
  infil_ch_drone_c_label: "Shoot it down",
  infil_ch_drone_c_desc: "Down the drone. Sure, but it leaves traces.",
  infil_ev_guard_shift_cat: "Infiltration Case / Corporate State",
  infil_ev_guard_shift_title: "Guard Shift Change",
  infil_ev_guard_shift_desc: "A shift change opens a brief window in the watch.",
  infil_ch_guard_shift_a_label: "Wait for the swap",
  infil_ch_guard_shift_a_desc: "Wait for the gap and move on the change.",
  infil_ch_guard_shift_b_label: "Pose as relief guard",
  infil_ch_guard_shift_b_desc: "Walk into the post as the relief guard.",
  infil_ch_guard_shift_c_label: "Ambush the guard",
  infil_ch_guard_shift_c_desc: "Jump the guard just before the swap.",
  infil_ev_vault_cat: "Infiltration Case / Corporate State",
  infil_ev_vault_title: "The Secret Vault",
  infil_ev_vault_desc: "A hidden vault holds the crown-jewel documents.",
  infil_ch_vault_a_label: "Skip the vault",
  infil_ch_vault_a_desc: "Leave the vault and grab only your target.",
  infil_ch_vault_b_label: "Crack the e-lock",
  infil_ch_vault_b_desc: "Hack the electronic lock and open it.",
  infil_ch_vault_c_label: "Blow the vault",
  infil_ch_vault_c_desc: "Blast it open and grab everything. Top reward.",
  infil_ev_vaccine_cat: "Infiltration Case / Corporate State",
  infil_ev_vaccine_title: "Vaccination Cover",
  infil_ev_vaccine_desc: "A pop-up clinic is the perfect cover to get inside.",
  infil_ch_vaccine_a_label: "Join the queue",
  infil_ch_vaccine_a_desc: "Line up as an ordinary patient.",
  infil_ch_vaccine_b_label: "Wear a medic gown",
  infil_ch_vaccine_b_desc: "Put on a medic gown and walk inside.",
  infil_ch_vaccine_c_label: "Impersonate the chief",
  infil_ch_vaccine_c_desc: "Pose as the director and dismiss the staff.",
  infil_ev_broadcast_cat: "Infiltration Case / Corporate State",
  infil_ev_broadcast_title: "Broadcast Control Room",
  infil_ev_broadcast_desc: "The station feed could carry your message — or your evidence.",
  infil_ch_broadcast_a_label: "Read the logs",
  infil_ch_broadcast_a_desc: "Quietly review the broadcast logs only.",
  infil_ch_broadcast_b_label: "Intercept the feed",
  infil_ch_broadcast_b_desc: "Hack the feed and siphon the data.",
  infil_ch_broadcast_c_label: "Pose as live director",
  infil_ch_broadcast_c_desc: "Impersonate the live director and take the room.",
  infil_ev_border_cat: "Infiltration Case / Corporate State",
  infil_ev_border_title: "Border Checkpoint",
  infil_ev_border_desc: "A guarded border stands between you and the target.",
  infil_ch_border_a_label: "Take an unwatched trail",
  infil_ch_border_a_desc: "Cross via an unmonitored back trail.",
  infil_ch_border_b_label: "Persuade the officer",
  infil_ch_border_b_desc: "Talk the inspector out of suspicion.",
  infil_ch_border_c_label: "Pose as a diplomat",
  infil_ch_border_c_desc: "Cross under a diplomatic cover identity.",
  infil_ch_border_d_label: "Ram the barrier",
  infil_ch_border_d_desc: "Smash the barrier with a vehicle and floor it.",
} as const;
